import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import React from "react";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";

interface Props {
    blockWholeDay: boolean | undefined
    showAlert: boolean
    setShowAlert: (show: boolean) => void
}

const BlockWholeDayPopup = (props: Props) => {
    const {t} = useLocalize()

    let message = props.blockWholeDay ? "No more reservations for this day" : "Chosen time is outside restaurant work hours!"

    return (
        <Dialog
            open={props.showAlert}
            onClose={() => props.setShowAlert(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t(message)}
            </DialogTitle>
            <DialogContent>
                {
                    props.blockWholeDay ?
                        <DialogContentText id="alert-dialog-description">
                            {t('This can be changed in comments section')}
                        </DialogContentText> :
                        <DialogContentText id="alert-dialog-description">
                            {t('If you want to update a reservation outside work hours, select reservation and change it manually.')}
                        </DialogContentText>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => props.setShowAlert(false)}>
                    {t('Close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BlockWholeDayPopup
